import React from "react";
import classNames from "classnames";
import { SectionTilesProps } from "../../utils/SectionProps";
import SectionHeader from "./partials/SectionHeader";
import { FaHtml5, FaCss3Alt, FaReact, FaPhp } from "react-icons/fa";
import { IoLogoJavascript } from "react-icons/io";
const propTypes = {
  ...SectionTilesProps.types,
};

const defaultProps = {
  ...SectionTilesProps.defaults,
};
const FeaturesTiles = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {
  const outerClasses = classNames(
    "features-tiles section",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  const innerClasses = classNames(
    "features-tiles-inner section-inner pt-0",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider"
  );

  const tilesClasses = classNames(
    "tiles-wrap center-content",
    pushLeft && "push-left"
  );

  const sectionHeader = {
    title: "Skills",
    paragraph:
      "Some languages and frameworks that i study and like to work with",
  };

  return (
    <section {...props} className={outerClasses}>
      <div className="container">
        <div className={innerClasses} style={{paddingTop: 80}}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <div className={tilesClasses}>
            <div className="tiles-item reveal-from-bottom">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <FaHtml5 color="#e34c26" size={64} />
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">HTML 5</h4>
                </div>
              </div>
            </div>

            <div
              className="tiles-item reveal-from-bottom"
              data-reveal-delay="200"
            >
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <FaCss3Alt color="#264de4" size={64} />
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">CSS3</h4>
                </div>
              </div>
            </div>

            <div
              className="tiles-item reveal-from-bottom"
              data-reveal-delay="400"
            >
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <IoLogoJavascript color="#F0DB4F" size={64} />
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">Javascript</h4>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                 <FaReact color="#2CC7E3" size={64}  />
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">ReactJS</h4>
                </div>
              </div>
            </div>

            <div
              className="tiles-item reveal-from-bottom"
              data-reveal-delay="200"
            >
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <FaReact color="#6978FF" size={64}  />
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">React Native</h4>
                </div>
              </div>
            </div>

            <div
              className="tiles-item reveal-from-bottom"
              data-reveal-delay="400"
            >
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                 <FaPhp color="#777BB3" size={64} />
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">PHP</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

FeaturesTiles.propTypes = propTypes;
FeaturesTiles.defaultProps = defaultProps;

export default FeaturesTiles;
